export default __webpack_public_path__ + "static/media/flower-detail.363301ed.png";